import { MigrationState } from '../models/vessel-migration-model';
import { authFetchGET, authFetchPOST } from '../utils/auth-fetch';

const env = (<any>window)["appenv"].services.voyMigrationService;

export class VesselMigrationService {
    static async getMigrationState() {
        try {
            const resp = await authFetchGET(env.scope, `${env.baseurl}/migration`);
            return resp.state;
        } catch(err) {
            console.warn(`Cannot get migration status. Err: ${err}`);
            return MigrationState.MigrationServiceNotFound;
        }
    }

    static async startMigration() {
        try {
            return await authFetchPOST(undefined, `${env.baseurl}/migration`, undefined);
        } catch(err) {
            console.warn(`Cannot start migration. Err: ${err}`);
            return null;
        }
    }
}
